import React from 'react';
import { graphql } from 'gatsby';
import {
  RenderRichTextData,
  ContentfulRichTextGatsbyReference,
} from 'gatsby-source-contentful/rich-text';

import Container from '@/components/Container';
import { ImageType } from '@/components/Image';
import { QuickFAQ } from '@/types/ContactBlock';

import PhoneBlock from './PhoneBlock';
import SendMessageBlock from './SendMessageBlock';
import QuickAnswerBlock from './QuickAnswerBlock';
import {
  BlockContent,
  CardsWrapper,
  ContactContainer,
} from './ContactBlock.styles';

export type Props = {
  id: string;
  locale: string;
  quickAnswerCardTitle: string;
  quickAnswerCardImage: ImageType;
  faqs: QuickFAQ[];
  sendMessageCardTitle: string;
  sendMessageCardText: string;
  sendMessageCardImage: ImageType;
  sendMessageFormButtonText: string;
  socialProviders: Array<string>;
  phoneCardTitle: string;
  phoneCardText: string;
  phoneCardImage: ImageType;
  phoneDisplayNewBadge: boolean;
  phoneAdditionalText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
};

const ContactBlock: React.FC<Props> = ({
  id,
  locale,
  quickAnswerCardImage,
  quickAnswerCardTitle,
  phoneCardTitle,
  phoneCardText,
  phoneCardImage,
  phoneDisplayNewBadge,
  phoneAdditionalText,
  sendMessageCardTitle,
  sendMessageCardText,
  sendMessageCardImage,
  sendMessageFormButtonText,
  socialProviders,
  faqs,
}) => {
  return (
    <ContactContainer id={id}>
      <Container>
        <BlockContent>
          <CardsWrapper>
            <QuickAnswerBlock
              title={quickAnswerCardTitle}
              image={quickAnswerCardImage}
              faqs={faqs}
              locale={locale}
            />
            <SendMessageBlock
              title={sendMessageCardTitle}
              text={sendMessageCardText}
              image={sendMessageCardImage}
              formButtonText={sendMessageFormButtonText}
              socialProviders={socialProviders}
              locale={locale}
            />
            <PhoneBlock
              title={phoneCardTitle}
              text={phoneCardText}
              image={phoneCardImage}
              phoneDisplayNewBadge={phoneDisplayNewBadge}
              phoneAdditionalText={phoneAdditionalText}
            />
          </CardsWrapper>
        </BlockContent>
      </Container>
    </ContactContainer>
  );
};

export default ContactBlock;

export const ContactBlockFragmentQuery = graphql`
  fragment ContactBlockFragment on ContentfulContactBlock {
    id
    __typename # Keep this as it's used to know which block type to display
    sendMessageCardImage {
      gatsbyImageData(width: 336)
      ...ImageFragment
    }
    sendMessageCardText
    sendMessageCardTitle
    sendMessageFormButtonText
    socialProviders
    phoneCardImage {
      gatsbyImageData(width: 336)
      ...ImageFragment
    }
    phoneCardText
    phoneCardTitle
    phoneDisplayNewBadge
    phoneAdditionalText {
      ...RichTextFragment
    }
    quickAnswerCardImage {
      gatsbyImageData(width: 336)
      ...ImageFragment
    }
    quickAnswerCardTitle
    faqs {
      ... on ContentfulSupportArticle {
        __typename
        title
        page {
          slug
        }
      }
      ... on ContentfulFaqMainTheme {
        __typename
        title
        support_theme_page_type {
          page {
            slug
          }
        }
      }
    }
  }
`;
